/**
 * This plugin was developed to enhance the user experience by ensuring returning users are reminded of items in their cart.
 * When a returning user visits the site and has items in their cart, the mini cart dialog will automatically open if the viewport is in lg (Desktop). This functionality aims to increase conversion rates by encouraging users to complete their purchases.
 *
 * For more details, please refer to the Jira ticket: GLOBAL15-101190.
 */

const enum Event {
  ping = 'ping',
  pong = 'pong'
}

export default defineNuxtPlugin(({ hook }) => {
  const { brand } = useRuntimeConfig().public
  const locale = useLocale()
  const { totalItems } = useCartStore()
  const { DialogMiniCart } = useDialogsStore()
  const { lg } = useNuxtApp().$viewport

  /**
   * This promise is used to detect if app is already open in another tab.
   * If it is, than app:mounted event will not be triggered.
   */
  const promise = new Promise((resolve) => {
    const channel = new BroadcastChannel(`${brand}-${locale}`)
    channel.postMessage(Event.ping)
    channel.onmessage = (event) => {
      switch (event.data) {
        case Event.ping:
          return channel.postMessage(Event.pong)
        case Event.pong:
          return resolve(false)
      }
    }
    setTimeout(resolve, 1000, true)
  })

  hook('app:mounted', async () => {
    if (await promise) {
      const isReturningUser = localStorage.getItem('isReturningUser')
      const isPageRefreshed = sessionStorage.getItem('isPageRefreshed')
      if (!isReturningUser) localStorage.setItem('isReturningUser', 'true')
      else if (!isPageRefreshed && totalItems && lg) DialogMiniCart.open()
      sessionStorage.setItem('isPageRefreshed', 'true')
    }
  })
})
